'use client';
import { from } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import {
	ClaropaySDKApi,
	ICardClaroPay,
	IProcessPayment,
	IUserConfirmation,
	IUserPasswordLess,
} from '@claropay/web-portal-sdk';
import * as claropaywebsdk from '@claropay/web-portal-sdk'

let claropaywebportalsdk: ClaropaySDKApi;

export const useClaropaySdk = () => {


	const initialize = (bundleId: string, bundleVersion) => {
		const isContainer =
       process.env.REACT_APP_TELCEL_BUNDLE_VERSIONS && process.env.REACT_APP_TELCEL_BUNDLE_VERSIONS.includes(bundleId) || false;

		const tokenizationConfig = JSON.parse(
			window.atob(
				process.env.REACT_APP_SDK_TOKENIZATION_DEFAULT
					? process.env.REACT_APP_SDK_TOKENIZATION_DEFAULT
					: "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",
			),
		);
		const defaultTokenization =
			bundleVersion && tokenizationConfig[bundleVersion]
				? tokenizationConfig[bundleVersion]
				: tokenizationConfig["default"];
		claropaywebportalsdk = new claropaywebsdk.ClaropaySDKApi(
			`${process.env.REACT_APP_SDK_API_KEY}`,
			(resourceInformation: any, errorInitialize: any) => {
				console.log("*** WEB SDK Launch ***");
				// claropaywebportalsdk.setState("minimalAppSync", "", () => {}, () => {});
			},
			{
				bundleVersion: bundleVersion,
				countryId: `${process.env.REACT_APP_APPSYNC_COUNTRY_ID}`,
				bundleId:
					bundleId && bundleId !== null
						? bundleId
						: `${process.env.REACT_APP_CLARO_PAY_BUNDLE_VERSION_DEFAULT}`,
				apiKey: process.env.REACT_APP_SDK_API_KEY
					? process.env.REACT_APP_SDK_API_KEY
					: '',
				claroID: process.env.REACT_APP_SDK_CLARO_ID,
				apiKeyClaroID: process.env.REACT_APP_SDK_API_KEY_CLARO_ID,
				passwordLess: process.env.REACT_APP_SDK_API_PASSWORDLESS,
				apiKeyPasswordLess: process.env.REACT_APP_SDK_API_KEY_PASSWORDLESS,
				appsync: process.env.REACT_APP_SDK_API_APPSYNC,
				apiKeyAppsync: process.env.REACT_APP_SDK_API_KEY_APPSYNC,
				calculadoraComisiones:
					process.env.REACT_APP_SDK_API_CALCULADORA_COMISIONES,
				apiKeyCalculadoraComisiones:
					process.env.REACT_APP_SDK_API_KEY_CALCULADORA_COMISIONES,
				cardManagement: process.env.REACT_APP_SDK_API_CARD_MANAGEMENT,
				apiKeyCardManagement:
					process.env.REACT_APP_SDK_API_KEY_CARD_MANAGEMENT,
				proxyService: process.env.REACT_APP_SDK_API_PROXY_SERVICE,
				apiKeyProxyService: process.env.REACT_APP_SDK_API_KEY_PROXY_SERVICE,
				binesCatalog: process.env.REACT_APP_SDK_BINES_CATALOG,
				messagingCatalog: process.env.REACT_APP_SDK_MESSAGING_CATALOG,
				apiKeyMessagingCatalog:
					process.env.REACT_APP_SDK_API_KEY_MESSAGING_CATALOG,
				appVersion: process.env.REACT_APP_SDK_APP_VERSION,
				payment: process.env.REACT_APP_SDK_API_PAYMENT,
				apikeyPayment: process.env.REACT_APP_SDK_API_KEY_PAYMENT,
				processKey: window.atob(
					process.env.REACT_APP_SDK_PASSWORD_ENCRYPT
						? process.env.REACT_APP_SDK_PASSWORD_ENCRYPT
						: '4a$NGEkc1dvcjBs',
				),
				checkPayment: process.env.REACT_APP_SDK_CHECK_PAYMENT,
				apiKeycheckPayment: process.env.REACT_APP_SDK_API_KEY_CHECK_PAYMENT,
				validateAccountNumber: process.env.REACT_APP_VALIDATE_ACCOUNT_NUMBER,
				apiKeyValidateAccountNumber: process.env.REACT_APP_KEY_VALIDATE_ACCOUNT_NUMBER,
				createCard: isContainer? process.env.REACT_APP_CREATE_CARD_V2 : process.env.REACT_APP_CREATE_CARD,
				apiKeyCreateCard: process.env.REACT_APP_KEY_CREATE_CARD,
				deleteCard: process.env.REACT_APP_DELETE_CARD,
				apiKeyDeleteCard: process.env.REACT_APP_KEY_DELETE_CARD,

				tokenizationCardMicrofront: process.env.REACT_APP_SDK_TOKENIZATION_APP_ID,
				useProxySessionTags: false,
				useProxyAppSync: false,
				useProxySearchCard:
					`${process.env.REACT_APP_SDK_API_SEARCH_CARD_USE_PROXY}` === "true",

				searchCard: process.env.REACT_APP_SDK_API_SEARCH_CARD,
				apiKeySearchCard: process.env.REACT_APP_SDK_API_KEY_SEARCH_CARD,
				webProxyServer: process.env.REACT_APP_SERVICE_PROXY_SERVER,
				apiKeyWebProxyServer: process.env.REACT_APP_SERVICE_PROXY_SERVER_API_KEY,

				appByKey: process.env.REACT_APP_SERVICE_APP_BY_KEY,
				apiKeyAppByKey: process.env.REACT_APP_SERVICE_APP_BY_KEY_API_KEY,

				defaultTokenization: defaultTokenization,
				minimalAppSync: process.env.REACT_APP_SDK_API_MINIMAL_APP_SYNC,
				apiKeyMinimalAppSync: process.env.REACT_APP_SDK_API_KEY_MINIMAL_APP_SYNC,
        		useSkipWebProxyServerForVesta: true,

				timeoutWebProxyServerForVesta: 4000,
				
				profile: process.env.REACT_APP_SERVICE_PROFILE_CACHED,
				apiKeyProfile: process.env.REACT_APP_SERVICE_PROFILE_CACHED_API_KEY,
			},
		);
	};

	const wrapperObservable = (pusblish: any) => {
		console.debug('wrapperObservable');
		return from(pusblish).pipe(
			map((x: any) => {
				return JSON.parse(x);
			}),
			catchError((error) => {
				return of({
					success: false,
					data: {
						error: error.toString(),
					},
				}).pipe((x) => x);
			}),
		);
	};

	const setState = (id: string, state: any) => {
		console.debug(`id ${id}, state ${state}`);
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.setState(
					id,
					state,
					(result: any) => {
						console.log('Set State success');
						resolve(result);
					},
					(error: any) => {
						console.log('Set State error');
						reject(error);
					}
				)
			} catch (error) {
				console.log('Set State catch');
				reject(error);
			}
		})
	};

	const getState = (id: string) => {
		console.debug(`id ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.getState(id, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const userExist = (id: string) => {
		console.debug(`id, string ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.userExist(id, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const createUserPasswordLess = (userPasswordLess: IUserPasswordLess) => {
		console.debug(
			`userPasswordLess, IUserPasswordLess ${JSON.stringify(userPasswordLess)}`,
		);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.createUserPasswordLess(
				userPasswordLess,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
		// mock for testing
		// return of({
		//   success: true,
		//   data: {
		//     msisdn: '+528126275000',
		//     username: '3b54ad9d-c578-447c-910b-09a9273ae624',
		//     session: '48b0a50a-ac8a-4f1e-ae31-efee21f11a7d',
		//     secondsForNewRequest: 30,
		//     countOTPs: 1,
		//     creationDate: 1693947953874,
		//     tokenOperation: '83c24a85e3822fa21a0909c070ad1abc',
		//   },
		// }).pipe((x: any) => x);
	};

	const confirmationCodeNewUserPasswordLess = (user: IUserConfirmation) => {
		console.debug(`user: IUserConfirmation ${JSON.stringify(user)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.confirmationCodeNewUserPasswordLess(
				user,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
		// mock for testing
		// return of({
		//   access_token: 'eyJraWQiOiJ2WU5XcFlBcTJ4ZStrREdTRDZ5TjMxO...',
		//   expires_in: 3600,
		//   id_token: 'eyJraWQiOiI2VHM3OERi...',
		//   refresh_token: 'eyJjdHkiOiJKV1QiL...',
		//   token_type: 'Bearer',
		//   tokenOperation: 'af0deeb...',
		// }).pipe((x: any) => x);
	};

	const resendCodeUserPasswordLess = (userPasswordLess: IUserPasswordLess) => {
		console.debug(`userPasswordLess ${JSON.stringify(userPasswordLess)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.resendCodeUserPasswordLess(
				userPasswordLess,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const initTokenUserPasswordLess = (phone: string) => {
		console.debug(`phone, string ${phone}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.initTokenUserPasswordLess(phone, "SMS", resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const generateTokenUserPasswordLess = (
		msisdn: string,
		code: string,
		session: string,
	) => {
		console.debug(`msisdn, string ${msisdn}`);
		console.debug(`code, string ${code}`);
		console.debug(`session, string ${session}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.generateTokenUserPasswordLess(
				msisdn,
				code,
				session,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const getToken = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getToken(resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const createUserTemporal = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.createUserTemporal(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const permanentUser = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.permanentUser(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const deleteUser = (phoneNumber: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.deleteUser(phoneNumber, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const logout = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.logout(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const trustUser = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.trustUser(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getProfile = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getProfile(resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const appSync = (
		countryId: string,
		bundleID: string,
		bundleVersion: string,
		bankId: string,
	) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.appSync(
					countryId,
					bundleID,
					bundleVersion,
					bankId,
					(result: any) => {
						console.log("AppSync success");
						resolve(result);
					},
					(error: any) => {
						console.log("AppSync error");
						reject(error);
					}
				);
			} catch (error) {
				console.log("AppSync catch");
				reject(error);
			}
		})
	};

	const searchCard = () => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.searchCard(resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const saveCard = (card: ICardClaroPay) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.saveCard(
					card,
					(result: any) => {
						console.log("Save card success");
						resolve(result);
					},
					(error: any) => {
						console.log("Save card error");
						reject(error);
					},
					true,
				);
			} catch (error) {
				console.log("Save card catch");
				reject(error);
			}
		});
	};
	const openTokenizationCard = (
		idContainer: string,
		configuration: claropaywebsdk.ITokenizationConfig,
		onEvent: any,
		claropaySDKMobileApiInstance: any
	) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.openTokenizationCard(
					idContainer,
					configuration,
					onEvent,
					claropaySDKMobileApiInstance,
					(result: any) => {
						console.debug("Save card success");
						resolve(result);
					},
					(error: any) => {
						console.debug("Save card error");
						reject(error);
					}
				);
			} catch (error) {
				console.debug("Save card catch");
				reject(error);
			}
		});
	};

	const processPayment = (
		payment: IProcessPayment,
		geo: claropaywebsdk.IGeolocalization
	) => {
		console.log('hook');
		console.log(payment);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.processPayment(
				payment,
				geo,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const calculateCommission = (
		serviceId: string,
		merchantId: string,
		amount: string,
		isClaroPay: string,
		cardId: string,
		appVersion: string,
		isClaroPartner: string,
	) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.calculateCommission(
				serviceId,
				merchantId,
				amount,
				isClaroPay,
				cardId,
				appVersion,
				isClaroPartner,
				resolve,
				reject,
			);
		});
		return wrapperObservable(publish);
	};

	const downloadBinesCatalog = () => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.downloadBinesCatalog(resolve, reject);
		});
		// return wrapperObservable(publish);
	};

	const downloadMessaggingClaropay = (bundleId: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.downloadMessaggingClaropay(bundleId, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getMessaggingClaropay = (flux: string, code: string, bundleId: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.getMessaggingClaropay(flux, code, bundleId, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const setToken = (isTemporalUser: boolean, token: any) => {
		return new Promise((resolve, reject) => {
			try {
				claropaywebportalsdk.setToken(
					token,
					(result: any) => {
						console.log("Set token success")
						resolve(result);
					},
					(error: any) => {
						console.log("Set token error");
						reject(error);
					}
				);
			} catch (error) {
				console.log("Set token catch");
				reject(error);
			}
		});
	};

	const getBin = (bin: string) => {
		return new Promise(function (resolve, reject) {
			claropaywebportalsdk.getBin(bin, resolve, reject);
		});
		//return wrapperObservable(publish);
	};

	const termsConditions = (msisdn: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.termsConditions(msisdn, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const checkPayment = (authorizationId: string) => {
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.checkPayment(authorizationId, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const getBinInline = (bin: string) => {
		return claropaywebportalsdk.getBinInline(bin);
	};

	const sendOTP = (id: string, mail: string) => {
		console.debug(`id, string ${id}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.sendOTP(id, mail, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	const validateOTP = (user: IUserConfirmation) => {
		console.debug(`user: IUserConfirmation ${JSON.stringify(user)}`);
		const publish = new Promise(function (resolve, reject) {
			claropaywebportalsdk.validateOTP(user, resolve, reject);
		});
		return wrapperObservable(publish);
	};

	return {
		initialize,
		setState,
		getState,
		userExist,
		createUserPasswordLess,
		confirmationCodeNewUserPasswordLess,
		resendCodeUserPasswordLess,
		initTokenUserPasswordLess,
		generateTokenUserPasswordLess,
		getToken,
		createUserTemporal,
		permanentUser,
		deleteUser,
		logout,
		getProfile,
		trustUser,
		appSync,
		searchCard,
		saveCard,
		openTokenizationCard,
		processPayment,
		calculateCommission,
		downloadBinesCatalog,
		downloadMessaggingClaropay,
		getMessaggingClaropay,
		setToken,
		getBin,
		getBinInline,
		termsConditions,
		checkPayment,
		sendOTP,
		validateOTP,
	};
};

